<ng-container *ngIf="pagination | async as pagination">
    <div *ngIf="pagination.total > filters.value.take" class="flex items-center justify-end mt-4">
        <div class="mr-2">Showing {{ filters.value.skip + 1 }} - {{ (filters.value.skip + filters.value.take) <
                pagination.total ? filters.value.skip + filters.value.take : pagination?.total }} of {{
                pagination?.total }}</div>
                <div (click)="previousPage()" class="cursor-pointer mr-2" [class.text-gray-300]="!canPrevious">
                    < </div>
                        <div (click)="nextPage()" class="cursor-pointer" [class.text-gray-300]="!canNext">
                            > </div>
                </div>
